/**
 * 代码中常用的常量值定义
 */

export const pageConstant = {
  'storageSyncUserKey': 'user',
  'okCode': 0,
  'fangKeXingBie': [
    {
      value: '0',
      key: '男'
    },
    {
      value: '1',
      key: '女'
    }
  ],
  'userType': [
    {
      value: 'USER',
      key: '用户'
    },
    {
      value: 'GUEST',
      key: '访客'
    },
  ]
}

export default {
  pageConstant
}